module.exports = __webpack_public_path__ + "img/top1.43a4efa8.png";